// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5641) return "static/chunks/5641-ed0769b2d8731a2e.js";
	if (chunkId === 9624) return "static/chunks/9624-82f906b49fad3275.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1315":"ec701ae167cfe2e4","2356":"01430521721a13cf"}[chunkId] + ".js";
};